// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1D2EL","col":"styles_col__3pRs6"};